var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box padding-right-col" }, [
    _c(
      "div",
      {
        staticClass:
          "widget-preview grid has-text-centered has-text-white gap-10px",
        style: { "grid-template-rows": "repeat(" + _vm.countHeight + ", 20vh)" }
      },
      [
        _vm.widgetSettingsData.length
          ? _vm._l(_vm.formatDataIntoGrids, function(widgetSetting) {
              return _c(
                "div",
                {
                  key: "preview-widget-setting-" + widgetSetting._id,
                  staticClass:
                    "widget-preview__item has-background-info is-flex is-align-items-center is-justify-content-center radius-rounded",
                  style: {
                    "grid-row": widgetSetting.row,
                    "grid-column": widgetSetting.column
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(widgetSetting.order) +
                      " - " +
                      _vm._s(
                        _vm.$t("widget_setting." + widgetSetting.feature)
                      ) +
                      " "
                  )
                ]
              )
            })
          : _vm._l(_vm.defaultsWidtget, function(widget) {
              return _c(
                "div",
                {
                  key: "preview-widget-" + widget.order,
                  staticClass:
                    "widget-preview__item has-background-info is-flex is-align-items-center is-justify-content-center radius-rounded"
                },
                [_vm._v(" " + _vm._s(widget.order) + " ")]
              )
            })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }